import BotonLogin from './boton_login'
import Quien from './quien'

const tam = window.innerWidth > 640

export default function Barra(props) {
    return (<>
        <div className="w-full bg-gray-800 flex items-center justify-between">
            <div className="p-2">
                <img src="logo.png" alt="" width={tam ? "50" : '30'}/>
            </div>
            <div className="text-gray-200 md:text-3xl">Club Social y Deportivo Río Negro</div>
            <div className="bg-gray-800 p-2 flex flex-row justify-between">
                {props.setIsOpen!== undefined ? (<>
                    <div className="p-2">
                       <BotonLogin setIsOpen={props.setIsOpen} />
                    </div>
                    </>)
                :
                tam ?
                    <Quien datos_u={props.datos_u}/>
                :
                ''
                }
            </div>
        </div>
    </>)
}